<mat-toolbar color="primary">
  <span id="møte-rediger-dialog-tittel">
    @if (tilstand() == 'laster') {
      {{ "Rediger ..."|translate }}
    } @else {
      {{ "Rediger {moetenummer} {moetenavn} - {gruppetittel} ({organisasjonsnavn})"|translate: {moetenummer: moete()!.nummer, moetenavn: gruppe()!.moetenavn, gruppetittel: gruppe()!.tittel, organisasjonsnavn: gruppe()!.organisasjonsnavn} }}
    }
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>
@if (erAvholdt()) {
  <div class="avholdt-møte">
    {{ "Du redigerer innholdet i et møte som er avholdt. Vil du fortsette?"|translate }}
    <a (click)="gaaTilRedigerReferat()">{{ "Klikk her for å redigere referatet/protokollen til dette møtet."|translate }}</a>
  </div>
}

<form [formGroup]="skjema" (ngSubmit)="lagre()">

  <mat-stepper linear="true" class="e2e-redigermoeteskjema" #steg>
    <mat-step [stepControl]="skjema.controls.detaljer" label="{{'Møtedetaljer'|translate}}">
      <div class="e2e-steg-møtedetaljer">
        <mat-dialog-content #skjemaKontainerDetaljer>
          <h2>{{ "Legg inn møtedetaljer"|translate }}</h2>
          <moete-rediger-detaljer [skjema]="skjema.controls.detaljer" [gruppeId]="gruppe()?.id"/>
        </mat-dialog-content>
        <mat-dialog-actions>
          <div class="handlinger">
            <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainerDetaljer" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
            <div class="senter">
              <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
              <button mat-raised-button type="button" color="primary"
                      cdkFocusInitial matStepperNext [disabled]="skjema.controls.detaljer.invalid"
                      class="e2e-neste-steg" data-testid="neste">
                {{ "Neste"|translate }}
              </button>
            </div>
            <button mat-button type="submit" color="primary" cdkFocusInitial
                    [visSpinner]="lagrer()" [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}"
                    class="høyre e2e-lagre">
              {{ "Lagre møte"|translate }}
            </button>
          </div>
        </mat-dialog-actions>
      </div>
    </mat-step>

    @if (erGeneralforsamling()) {
      <mat-step [stepControl]="skjema.controls.aksjeeiere" optional="false" label="{{'Representasjon'|translate}}">
        <div class="e2e-steg-representasjon">
          <mat-dialog-content #skjemaKontainerRepresentasjon>
            <h2>{{ "Representasjon"|translate }}</h2>
            <div class="representasjon">
              <generalforsamling-rediger-representasjoner [skjema]="skjema.controls.aksjeeiere" [gruppe]="gruppe()!" [standardAksjeeierRolle]="standardAksjeeierRolle()"/>
            </div>
          </mat-dialog-content>
          <mat-dialog-actions>
            <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainerRepresentasjon" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
            <div class="handlinger">
              <div class="senter">
                <button mat-button type="button" matStepperPrevious>{{ "Tilbake"|translate }}</button>
                <button mat-raised-button type="button" color="primary" cdkFocusInitial matStepperNext
                        [disabled]="skjema.controls.aksjeeiere.invalid" class="e2e-neste-steg">
                  {{ "Neste"|translate }}
                </button>
              </div>
              <button mat-button type="submit" color="primary" cdkFocusInitial
                      [visSpinner]="lagrer()" [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}"
                      class="høyre">
                {{ "Lagre møte"|translate }}
              </button>
            </div>
          </mat-dialog-actions>
        </div>
      </mat-step>
    }

    <mat-step [stepControl]="skjema" label="{{'Deltakere'|translate}}">
      <div class="_deltakere e2e-steg-deltakere">
        <mat-dialog-content #skjemaKontainerDeltakere>
          <h2>{{ "Hvem skal delta på møtet?"|translate }}</h2>
          <div class="deltakere">
            @if (erGeneralforsamling()) {
              <moete-rediger-deltakere-gf [deltakereSkjema]="skjema.controls.deltakere"
                                          [representasjonerSkjema]="skjema.controls.aksjeeiere"
                                          skalSignereValgSynlig="false"
                                          (vedGaaTilRepresentasjonSteg)="gaaTilRepresentasjonSteg()"/>
            } @else {
              <moete-rediger-deltakere [skjema]="skjema.controls.deltakere" skalSignereValgSynlig="false"/>
            }
            <moete-rediger-eksterne-deltakere [skjema]="skjema.controls.eksterneDeltakere"/>
          </div>
        </mat-dialog-content>
        <mat-dialog-actions>
          <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainerDeltakere" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
          <div class="handlinger">
            <div class="venstre"></div>
            <div class="senter">
              <button mat-button matStepperPrevious>{{ "Tilbake"|translate }}</button>
              <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()"
                      [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}" class="e2e-lagre">
                {{ "Lagre møte"|translate }}
              </button>
            </div>
            <div class="høyre">
              @if (nyeDeltakereLagtTil().length > 0) {
                <mat-slide-toggle [formControl]="skjema.controls.sendInnkalling" class="e2e-sendInnkalling">
                  {{ "Send e-post med møteinnkalling til {antall} nye deltakere"|translate: {antall: nyeDeltakereLagtTil().length} }}
                </mat-slide-toggle>
              }
            </div>
          </div>
        </mat-dialog-actions>
      </div>
    </mat-step>
  </mat-stepper>
</form>
